module.exports = __webpack_public_path__ + "img/paypal.1c58bd37.png";